import {
  CreateProfileDto,
  IRequestConfig,
  IRequestOptions,
  Profile,
  ShApiResponse_Boolean,
  ShApiResponse_Byte,
  ShApiResponse_CreateProfilesResponse,
  ShApiResponse_EcgMetaData,
  ShApiResponse_GetProfileDto,
  ShApiResponse_GetProfileEcgListDto,
  ShApiResponse_List_GetEcgHeaderDto,
  ShApiResponse_List_GetProfileDto,
  ShApiResponse_List_GetTreeViewEcgDto,
  ShApiResponse_List_Profile,
  ShApiResponse_List_ProfileEcg,
  ShApiResponse_List_USState,
  ShApiResponse_Profile,
  ShApiResponse_String,
  UpdateProfileDto,
  axios,
  basePath,
  getConfigs,
} from "./index.defs";

export class ProfilesApiService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   * Get the authenticated user's profiles list.
   */
  static profilesGetProfilesV2(
    params: {
      /** indicates whether to get the EcgHasNewInfo data or not */
      detailed?: boolean;
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
      /** true-return only archived profiles, false-non archived, null-all */
      isArchived?: boolean;
      /** How to sort the returned ecgs list ("name" - by the account name, ascending; "last-ecg" - by the ecg date/time, descending */
      sort?: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_List_GetProfileDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/v2/profiles";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );
      configs.params = {
        detailed: params["detailed"],
        page: params["page"],
        pageSize: params["pageSize"],
        isArchived: params["isArchived"],
        sort: params["sort"],
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Creates a single profile under the authenticated user
   */
  static profilesCreateProfile(
    params: {
      /**  */
      profileDto: CreateProfileDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetProfileDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/v2/profiles";

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["profileDto"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get the authenticated user's profiles list
   */
  static profilesGetProfiles(
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_List_Profile> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/profiles";

      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns the profile list of the given user. Available for Api users only.
   */
  static profilesGetCustomerProfiles(
    params: {
      /** The unique identifier of the user whose profiles list to return */
      userId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_List_Profile> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/{userId}/profiles";
      url = url.replace("{userId}", params["userId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Adds the given list of profiles to the
   */
  static profilesCreateProfiles(
    params: {
      /** The unique identifier of the user to add the profiles to */
      userId: string;
      /** The list of profiles to add */
      profiles: Profile[];
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_CreateProfilesResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/users/{userId}/profiles";
      url = url.replace("{userId}", params["userId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["profiles"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Update the given profile
   */
  static profilesUpdateProfileV2(
    params: {
      /** The unique identifier of the profile */
      profileGuid: string;
      /** The profile data to update */
      profile: UpdateProfileDto;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetProfileDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/v2/profiles/{profileGuid}";
      url = url.replace("{profileGuid}", params["profileGuid"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "patch",
        "application/json",
        url,
        options
      );

      let data = params["profile"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Update the given profile
   */
  static profilesUpdateProfile(
    params: {
      /** The unique identifier of the profile */
      profileGuid: string;
      /** The profile data to update */
      prof: Profile;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Profile> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/profiles/{profileGuid}";
      url = url.replace("{profileGuid}", params["profileGuid"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "put",
        "application/json",
        url,
        options
      );

      let data = params["prof"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Deletes the given profile from the profiles list
   */
  static profilesDeleteProfile(
    params: {
      /** The unique identifier of the profile to delete */
      profileGuid: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Boolean> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/profiles/{profileGuid}";
      url = url.replace("{profileGuid}", params["profileGuid"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "delete",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Return the list of ECGs of the given profile
   */
  static profilesGetProfileEcgs(
    params: {
      /** The unique identifier of the profile whose ECGs to return */
      profileGuid: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_List_ProfileEcg> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/profiles/{profileGuid}/ecgs";
      url = url.replace("{profileGuid}", params["profileGuid"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Transmits an ECG for the given profile id
   */
  static profilesTransmitProfileEcg(
    params: {
      /** The unique identifier of profile */
      profileGuid: string;
      /** The ECG data in xml format */
      ecgXml: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_String> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/profiles/{profileGuid}/ecgs";
      url = url.replace("{profileGuid}", params["profileGuid"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "post",
        "application/json",
        url,
        options
      );

      let data = params["ecgXml"];

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns the xml report of the given profile's given ECG
   */
  static profilesGetProfileEcgXml(
    params: {
      /** The unique identifier of profile */
      profileGuid: string;
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_Byte> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/profiles/{profileGuid}/ecgs/{ecgId}/xml";
      url = url.replace("{profileGuid}", params["profileGuid"] + "");
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns the metadata of the the given profile's given ECG
   */
  static profilesGetEcgMetaData(
    params: {
      /** The unique identifier of profile */
      profileGuid: string;
      /** The unique identifier of the ECG */
      ecgId: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_EcgMetaData> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/profiles/{profileGuid}/ecgs/{ecgId}/metadata";
      url = url.replace("{profileGuid}", params["profileGuid"] + "");
      url = url.replace("{ecgId}", params["ecgId"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns a list of basic info about ecgs performed by the given profile. Useful for ecg comparission
   */
  static profilesGetEcgHeaders(
    params: {
      /** The unique identifier of the profile */
      profileGuid: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_List_GetEcgHeaderDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/profiles/{profileGuid}/ecgs/headers";
      url = url.replace("{profileGuid}", params["profileGuid"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Return the list of ECGs of the given profile
   */
  static profilesGetProfileEcgsV2(
    params: {
      /** The unique identifier of the profile whose ECGs to return */
      profileGuid: string;
      /** The results "page" number to return */
      page?: number;
      /** The number of result in each "page" */
      pageSize?: number;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_GetProfileEcgListDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/v2/profiles/{profileGuid}/ecgs";
      url = url.replace("{profileGuid}", params["profileGuid"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );
      configs.params = { page: params["page"], pageSize: params["pageSize"] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns a list of ecgs for the given profile
   */
  static profilesGetTreeViewProfileEcgs(
    params: {
      /** the unique identifier of the requested profile */
      profileGuid: string;
      /** true to return all ecgs, false will filter the archived */
      includeArchived?: boolean;
      /** The date from which to return the ECGs (yyyy-MM-dd) */
      ecgFromDate?: string;
      /** The date until which to return the ECGs (yyyy-MM-dd) */
      ecgToDate?: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_List_GetTreeViewEcgDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/profiles/{profileGuid}/tree-view/ecgs";
      url = url.replace("{profileGuid}", params["profileGuid"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );
      configs.params = {
        includeArchived: params["includeArchived"],
        ecgFromDate: params["ecgFromDate"],
        ecgToDate: params["ecgToDate"],
      };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static profilesGetProfileAllowedStates(
    params: {
      /**  */
      profileGuid: string;
      /** access token */
      authorization?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ShApiResponse_List_USState> {
    return new Promise((resolve, reject) => {
      let url = basePath + "/profiles/{profileGuid}/us-states";
      url = url.replace("{profileGuid}", params["profileGuid"] + "");

      options.headers = {
        Authorization: params["authorization"],
        ...options.headers,
      };
      const configs: IRequestConfig = getConfigs(
        "get",
        "application/json",
        url,
        options
      );

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
